var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intercom-tool-tip"},[_c('action-tool-tip',{attrs:{"icon-path":'icons/tooltip_chat_icon.svg',"text":_vm.text,"action-text":'הצוות שלנו ישמח לעזור לך בצ׳אט.',"handle-action":_vm.openIntercom}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }